import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import PlayGroundPage from '../views/PlayGroundPage.vue';
import TwitterClone from '../views/TwitterClone.vue';
import ProjectPage from '../views/ProjectPage.vue';
import ExplorationPage from '../views/ExplorationPage.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/playground', component: PlayGroundPage },
  { path: '/twitter-clone', component: TwitterClone },
  { path: '/project/:slug', component: ProjectPage },
  { path: '/exploration/:slug', component: ExplorationPage }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;